export const SET_STORAGE_SPACE_DIALOG_OPEN = 'SET_STORAGE_SPACE_DIALOG_OPEN';
export const SET_DELETE_ENTITY_OFFLINE_DATA_DIALOG_OPEN =
  'SET_DELETE_ENTITY_OFFLINE_DATA_DIALOG_OPEN';

export const setStorageSpaceDialogOpen = (flag) => ({
  type: SET_STORAGE_SPACE_DIALOG_OPEN,
  payload: {
    flag,
  },
});

export const setDeleteEntityOfflineDataDialogOpen = (flag, entityId) => ({
  type: SET_DELETE_ENTITY_OFFLINE_DATA_DIALOG_OPEN,
  payload: {
    flag,
    entityId,
  },
});
